import React, { useState } from "react";
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";

const mockData = Array.from({ length: 10 }, (_, i) => `Item ${i + 1}`);
console.log(mockData);
export default function DragAndDropTransferList(props) {
  const {
    ListOneName,
    ListTwoName,
    leftItems,
    setLeftItems,
    rightItems,
    setRightItems,
    updateTransferList,
  } = props;

  const [leftSearch, setLeftSearch] = useState("");
  const [rightSearch, setRightSearch] = useState("");

  const onDragStart = (event, item, source) => {
    event.dataTransfer.setData("item", JSON.stringify(item));
    event.dataTransfer.setData("source", source); // 'left' or 'right'
  };

  const onDrop = (event, target) => {
    event.preventDefault();
    const itemData = event.dataTransfer.getData("item");
    const source = event.dataTransfer.getData("source");

    if (!itemData || source === target) return;

    const item = JSON.parse(itemData);

    if (source === "left" && target === "right") {
      setLeftItems((prev) => prev.filter((i) => i.id !== item.id));
      setRightItems((prev) => [...prev, item]);
      updateTransferList(item.id, "true");
    } else if (source === "right" && target === "left") {
      setRightItems((prev) => prev.filter((i) => i.id !== item.id));
      setLeftItems((prev) => [...prev, item]);
      updateTransferList(item.id, "false");
    }
  };

  const allowDrop = (event) => event.preventDefault();

  // const updateItemLocation = async (item, targetList) => {
  //   try {
  //     const response = await fetch("/api/update-item-location", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ item, target: targetList }), // 'left' or 'right'
  //     });

  //     if (!response.ok) throw new Error("Failed to update location");

  //     console.log(`✅ Updated item "${item}" to ${targetList}`);
  //   } catch (error) {
  //     console.error("❌ API error:", error);
  //   }
  // };

  const renderList = (items, search, setSearch, title, side) => (
    <Paper
      onDrop={(e) => onDrop(e, side)}
      onDragOver={allowDrop}
      sx={{
        width: 300,
        height: 300,
        overflowY: "auto",
        p: 1,
        backgroundColor: "#f9f9f9",
        border: "2px solid #4b474730",
      }}
    >
      <Typography variant="subtitle1" sx={{ padding: 1 }} gutterBottom>
        {title}
      </Typography>
      <TextField
        size="small"
        fullWidth
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 1 }}
      />
      <List dense>
        {items
          .filter(
            (item) =>
              item.name &&
              item.name
                .toString()
                .toLowerCase()
                .trim()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") // removes accents
                .includes(
                  search
                    .toLowerCase()
                    .trim()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )
          )
          .map((item) => (
            <ListItem
              key={item.id}
              draggable
              onDragStart={(e) => onDragStart(e, item, side)}
              sx={{
                backgroundColor: "#fff",
                my: 0.5,
                border: "1px solid #ddd",
                borderRadius: 1,
                cursor: "grab",
              }}
            >
              <ListItemText primary={item.name} />
            </ListItem>
          ))}
      </List>
    </Paper>
  );

  return (
    <Box
      display="flex"
      gap={12}
      justifyContent="center"
      alignItems="center"
      mt={4}
    >
      {renderList(leftItems, leftSearch, setLeftSearch, ListOneName, "left")}
      {renderList(
        rightItems,
        rightSearch,
        setRightSearch,
        ListTwoName,
        "right"
      )}
    </Box>
  );
}
